<template>
	<div>
		<ion-checkbox v-model="isActionRequired" label-placement="end">
			<span class="text-sm font-medium text-gray-700">
				{{ t("note.action-required") }}
			</span>
		</ion-checkbox>
	</div>
</template>

<script setup lang="ts">
	import { IonCheckbox } from "@ionic/vue";
	import { useI18n } from "vue-i18n";

	const { t } = useI18n();
	const isActionRequired = defineModel<boolean>();
</script>
